'use client';

import { PageError, type RouteErrorProps } from '@/app/error-screens';

/** Work that did not load, in the lens frame (docs/LOADING.md tool 10; `src/app/error-screens.tsx`). */
export default function RouteError(props: RouteErrorProps) {
  return <PageError {...props} frame="lens" />;
}
